import React, {useEffect, useState} from "react";
import Button from "../../components/common/button/Button";

const ManageOwners = ({onFromSubmit,list, existingOwners}) => {
    const userItems = list.user.items;
    const [owners, setOwners] = useState([{ user: "", percentage: "" }]);
    const [error, setError] = useState("");
    const userList = userItems ? Object.entries(userItems).map(([id, name]) => ({ id, name })) : [];

    const handleAddRow = () => {
        setOwners(prev => [...prev, { user: "", percentage: "" }]);
    };

    const handleRemoveRow = (index) => {
        setOwners(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        if (existingOwners.length > 0) {
            setOwners([...existingOwners]);
        }
    }, [existingOwners]);

    // Function to update values in a row
    const handleInputChange = (index, field, value) => {
        if (field === "percentage" && value !== "" && !/^\d*$/.test(value)) {
            return; // Prevent non-numeric input
        }
        const updatedOwners = [...owners];
        updatedOwners[index][field] = value;
        setOwners(updatedOwners);
    };

    const handleSubmit = () => {
        const selectedUsers = owners.map(o => o.user);
        const hasDuplicates = new Set(selectedUsers).size !== selectedUsers.length;
        const totalPercentage = owners.reduce((sum, o) => sum + (Number(o.percentage) || 0), 0);

        if (owners.some(owner => owner.user === "")) {
            setError("All users must be selected.");
            return;
        }
        if (owners.some(owner => owner.percentage === "" || isNaN(owner.percentage) || owner.percentage < 0)) {
            setError("Percentage must be a valid number.");
            return;
        }
        if (hasDuplicates) {
            setError("Each user must be selected only once.");
            return;
        }
        if (totalPercentage > 100) {
            setError("Total percentage cannot exceed 100%.");
            return;
        }

        setError(""); // Clear errors if validation passes
        const ownersList = owners.map(owner => ({ ...owner, percentage: Number(owner.percentage) }));
        onFromSubmit(ownersList);
    };

    return (
        <div className="col-8">
            {owners.map((owner, index) => (
                <div key={index} className="d-flex gap-4 mb-3">
                    <select className="form-select" value={owner.user} onChange={(e) => handleInputChange(index, "user", e.target.value)}>
                        <option value="">Select User</option>
                        {userList.map(user => (
                            <option key={user.id} value={user.id}>{user.name}</option>
                        ))}
                    </select>

                    <div className="input-group">
                        <input type="text" className="form-control" placeholder="Percentage" value={owner.percentage} onChange={(e) => handleInputChange(index, "percentage", e.target.value)} />
                        <span className="input-group-text">%</span>
                    </div>

                    <button
                        className="btn btn-outline-success"
                        type="button"
                        onClick={handleAddRow}
                    >
                        +
                    </button>
                    {owners.length > 1 && (
                        <button
                            className="btn btn-outline-danger"
                            type="button"
                            onClick={() => handleRemoveRow(index)}
                        >
                            −
                        </button>
                    )}
                </div>
            ))}
            {error && <p className="text-danger fs-md fw-medium mb-1">{error}</p>}
            <Button className="bg-primary bg-opacity-75 bg-opacity-100-hover mt-2" onClick={handleSubmit}>Submit</Button>
        </div>
    );
};

export default ManageOwners;
